import { styled } from '@zeiss/beyond-online-react';
import * as React from 'react';

const Container = styled.div`
  padding: var(--spacing-s) var(--spacing-xs);
`;

interface AutocompleteEmptyStateProps {
  message: React.ReactNode;
}

export const AutocompleteEmptyState = ({
  message,
}: AutocompleteEmptyStateProps) => {
  return <Container>{message}</Container>;
};
